import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#0f4584',
                secondary: '#dd0e18'
            },
            dark: {
                primary: '#0f4584',
                secondary: '#dd0e18'
            },
        },
    },
});
